<template>
  <component :is="trainingData === undefined ? 'div' : 'b-card'">

    <!-- Alert: No item found -->
    <b-alert
      variant="danger"
      :show="trainingData === undefined"
    >
      <h4 class="alert-heading">
        Error fetching training data
      </h4>
      <div class="alert-body">
        No user found with this user id. Check
        <b-link
          class="alert-link"
          :to="{ name: 'apps-users-list'}"
        >
          User List
        </b-link>
        for other users.
      </div>
    </b-alert>

    <b-tabs
      v-if="trainingData"
      pills
    >

      <!-- Tab: Account -->
      <b-tab active>
        <template #title>
          <feather-icon
            icon="UserIcon"
            size="16"
            class="mr-0 mr-sm-50"
          />
          <span class="d-none d-sm-inline">{{ $t('Eğitim Bilgileri') }}</span>
        </template>
        <training-edit-tab-information
          :blank-training-data="trainingData"
          class="mt-2 pt-75"
        />
      </b-tab>
      <!-- Tab: Information -->
      <b-tab>
        <template #title>
          <feather-icon
            icon="InfoIcon"
            size="16"
            class="mr-0 mr-sm-50"
          />
          <span class="d-none d-sm-inline">{{ $t('Eğitim Soru ve Cevapları') }}</span>
        </template>
        <training-edit-tab-question :training-id="trainingData.id" />
      </b-tab>
    </b-tabs>
  </component>
</template>

<script>
import {
  BTab, BTabs, BCard, BAlert, BLink,
} from 'bootstrap-vue'
import { ref, onUnmounted } from '@vue/composition-api'
import router from '@/router'
import store from '@/store'
import trainingStoreModule from '../trainingStoreModule'
import trainingEditTabInformation from './TrainingEditTabInformation.vue'
import trainingEditTabQuestion from './TrainingEditTabQuestion.vue'

export default {
  components: {
    BTab,
    BTabs,
    BCard,
    BAlert,
    BLink,

    router,
    trainingEditTabInformation,
    trainingEditTabQuestion,
  },
  setup() {
    const trainingData = ref(null)

    const CUSTOMER_APP_STORE_MODULE_NAME = 'app-training'

    // Register module
    if (!store.hasModule(CUSTOMER_APP_STORE_MODULE_NAME)) store.registerModule(CUSTOMER_APP_STORE_MODULE_NAME, trainingStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(CUSTOMER_APP_STORE_MODULE_NAME)) store.unregisterModule(CUSTOMER_APP_STORE_MODULE_NAME)
    })
    store.dispatch('app-training/fetchSingleTraining', { id: router.currentRoute.params.id })
      .then(response => {
        trainingData.value = response.data.data
      })
      .catch(error => {
        if (error.response.status === 404) {
          trainingData.value = undefined
        }
      })

    return {
      trainingData,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/quill.scss';
</style>
